import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import EditIcon from "@mui/icons-material/Edit";
import { fetchBusinessDomain } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import DetailSection from "../../components/common/DetailSection";
import DetailField from "../../components/common/DetailField";

export default function BusinessKpiDetailPage() {
  const { businessDomainId, businessKpiId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [indicator, setIndicator] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const domain = await fetchBusinessDomain(businessDomainId);
        const idx = parseInt(businessKpiId, 10);
        setIndicator((domain.indicators || [])[idx] || null);
      } catch (e) {
        notify.apiError(e);
      }
    })();
  }, [businessDomainId, businessKpiId]);

  if (!indicator) return null;

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("businessKpi.detail.title")}</Typography>
        <Button variant="contained" startIcon={<EditIcon />} onClick={() => navigate(`/design/${businessDomainId}/business-kpis/${businessKpiId}/edit`)}>
          {t("common.edit")}
        </Button>
      </Box>
      <DetailSection>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}><DetailField label={t("businessKpi.indicatorName")} value={indicator.indicatorName} /></Grid>
          <Grid size={{ xs: 12, md: 6 }}><DetailField label={t("businessKpi.unit")} value={indicator.unit} /></Grid>
          <Grid size={12}><DetailField label={t("businessKpi.measuringMethod")} value={indicator.measuringMethod} /></Grid>
          <Grid size={12}><DetailField label={t("businessKpi.evaluationStandard")} value={indicator.evaluationStandard} /></Grid>
          <Grid size={12}><DetailField label={t("common.description")} value={indicator.description} /></Grid>
        </Grid>
      </DetailSection>
      <Button variant="outlined" sx={{ mt: 2 }} onClick={() => navigate(`/design/${businessDomainId}/business-kpis`)}>
        {t("common.back")}
      </Button>
    </Box>
  );
}
